import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-[2%] w-5/6"
}
const _hoisted_2 = { class: "w-full sm:w-auto grid justify-center h-full" }
const _hoisted_3 = { class: "p-1" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "m-[2%] w-5/6"
}
const _hoisted_7 = { class: "content-center h-full" }
const _hoisted_8 = { class: "text-7xl text-gray-500 font-bold text-center uppercase" }

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from "@/components/ui/carousel";
import {Card, CardContent} from "@/components/ui/card";
import {StepBack, X} from "lucide-vue-next";
import DeleteDialog from "@/components/tables/DeleteDialog.vue";
import {Button} from "@/components/ui/button";
import {onMounted, ref, watch} from "vue";
import {watchOnce} from "@vueuse/core";
import TablesService from "@/services/tables/tables.service";
import {useRoute} from "vue-router";
import Spinner from "@/components/ui_custom/spinner/Spinner.vue";
import useEventsBus from "@/utils/eventBus";
import {toast} from "@/utils/utils";
import {i18n} from "@/utils/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoRoofView',
  setup(__props) {

const photos: any = ref([]);
const route = useRoute();
const emblaMainApi = ref<CarouselApi>()
const emblaThumbnailApi = ref<CarouselApi>()
const selectedIndex = ref(0)
const isDeleteDialogOpen = ref(false);
const { bus } = useEventsBus()
let isLoading = ref(false);
let obj = {}

const setIsDeleteDialogOpen = (value: boolean, photoId: number) => {
  isDeleteDialogOpen.value = value;
  obj = { id: photoId };
};

function onSelect() {
  if (!emblaMainApi.value || !emblaThumbnailApi.value)
    return
  selectedIndex.value = emblaMainApi.value.selectedScrollSnap()
  emblaThumbnailApi.value.scrollTo(emblaMainApi.value.selectedScrollSnap())
}

function onThumbClick(index: number) {
  if (!emblaMainApi.value || !emblaThumbnailApi.value)
    return
  emblaMainApi.value.scrollTo(index)
}

watch(() => bus.value.get('delete_attachments'), async (value) => {
  photos.value = photos.value.filter(( photo: any ) => photo.id != value);
  toast.success(i18n.global.t('toast.delete_success'));
})

watchOnce(emblaMainApi, (emblaMainApi) => {
  if (!emblaMainApi)
    return

  onSelect()
  emblaMainApi.on('select', onSelect)
  emblaMainApi.on('reInit', onSelect)
})

onMounted(async () => {
  isLoading.value = true;
  const res = await TablesService.getAttachments(route.params.entity as string, route.params.id as string, 'photos');
  photos.value = res?.data
  isLoading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Spinner, { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"]),
    (photos.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"])),
            type: "button",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(StepBack), { class: "mr-2 h-5 w-5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('building.back')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Carousel), {
              class: "relative w-full max-w-lg",
              onInitApi: _cache[1] || (_cache[1] = (val) => emblaMainApi.value = val)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CarouselContent), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
                      return (_openBlock(), _createBlock(_unref(CarouselItem), {
                        class: "cursor-pointer",
                        key: photo.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(Card), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: `data:${photo.mimeType};base64, ${photo.data}`,
                                      alt: photo.fileName,
                                      class: "h-[100%] w-[100%] object-cover rounded-lg"
                                    }, null, 8, _hoisted_4),
                                    _createVNode(_unref(Button), {
                                      class: "absolute p-2 rounded-full bg-gray-200 text-red-700",
                                      onClick: _withModifiers(($event: any) => (setIsDeleteDialogOpen(true, photo.id)), ["prevent"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(X), { class: "h-6 w-6" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(CarouselPrevious)),
                _createVNode(_unref(CarouselNext))
              ]),
              _: 1
            }),
            _createVNode(_unref(Carousel), {
              class: "relative w-full max-w-lg",
              onInitApi: _cache[2] || (_cache[2] = (val) => emblaThumbnailApi.value = val)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CarouselContent), { class: "flex gap-1 ml-0" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo, index) => {
                      return (_openBlock(), _createBlock(_unref(CarouselItem), {
                        key: photo.id,
                        class: "pl-0 basis-1/4 cursor-pointer",
                        onClick: ($event: any) => (onThumbClick(index))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["p-1", index === selectedIndex.value ? '' : 'opacity-50'])
                          }, [
                            _createVNode(_unref(Card), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: `data:${photo.mimeType};base64, ${photo.data}`,
                                      alt: photo.filename,
                                      class: "h-[100%] w-[100%] object-cover rounded-lg"
                                    }, null, 8, _hoisted_5)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(Button), {
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"])),
            type: "button",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(StepBack), { class: "mr-2 h-5 w-5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('building.back')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('building.no_foto')), 1)
          ])
        ])),
    _createVNode(DeleteDialog, {
      entity: "attachments",
      object: _unref(obj),
      open: isDeleteDialogOpen.value,
      "set-open": setIsDeleteDialogOpen
    }, null, 8, ["object", "open"])
  ], 64))
}
}

})